import useAccessControls from 'modules/access-controls/atoms/use-access-controls';
import useCitiesSelect from 'modules/cities/hooks/use-cities-select';
import useCreateNotification from 'modules/notifications/hooks/use-create-notification';
import {
  NotificationProps,
  NotificationTypeEnum,
  translatedNotificationProps,
} from 'modules/notifications/types';
import weekDaySelect from 'modules/notifications/util/week-day-select';
import React from 'react';
import Creation from 'shared/layout/creation';
import useFormInputs from 'shared/migration-components/form/util';

const CreateNotification: React.FC = () => {
  const {
    getInput,
    getSwitch,
    getTextArea,
    getSelect,
    getDatePicker,
    getTimePicker,
  } = useFormInputs<NotificationProps>();
  const citiesSelect = useCitiesSelect();
  const {cityId} = useAccessControls();

  return (
    <Creation<NotificationProps>
      titleBar={{title: 'Cadastrar notificação'}}
      onSubmit={useCreateNotification}
      defaultValues={{active: true, cityId}}
      inputs={[
        getInput({
          name: 'title',
        }),
        getTextArea({name: 'body'}),
        getSelect({
          name: 'cityId',
          data: citiesSelect.data,
          isLoading: citiesSelect.isLoading,
          hidden: !!cityId,
        }),
        getSelect({
          name: 'type',
          data: [
            {label: 'Única', value: NotificationTypeEnum.oneTime},
            {label: 'Recorrente', value: NotificationTypeEnum.periodical},
          ],
        }),
        getSwitch({
          name: 'active',
          hidden: (data) => data.type !== NotificationTypeEnum.periodical,
        }),
        getSelect({
          name: 'day',
          data: weekDaySelect,
          hidden: (data) => data.type !== NotificationTypeEnum.periodical,
        }),
        getDatePicker({
          name: 'date',
          hidden: (data) => data.type !== NotificationTypeEnum.oneTime,
        }),
        getTimePicker({
          name: 'time',
          hidden: (data) => !data.type,
        }),
      ]}
      translationKey={translatedNotificationProps}
    />
  );
};

export default CreateNotification;
